import { render } from "./Fieldset.vue?vue&type=template&id=736b593b"
import script from "./Fieldset.vue?vue&type=script&lang=js"
export * from "./Fieldset.vue?vue&type=script&lang=js"

import "./Fieldset.vue?vue&type=style&index=0&id=736b593b&lang=css"
script.render = render

export default script